var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoDocuments = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 55,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.094 22.777H9.258c-.516 0-.935-.336-.935-.75s.42-.75.935-.75h25.835c.516 0 .935.336.935.75s-.418.75-.934.75ZM35.094 33.34H9.258c-.516 0-.935-.336-.935-.75s.42-.75.935-.75h25.835c.516 0 .935.336.935.75s-.418.75-.934.75ZM21.818 12.215H9.258c-.516 0-.935-.336-.935-.75s.42-.75.935-.75h12.559c.516 0 .935.336.935.75s-.418.75-.934.75ZM35.094 43.902H9.258c-.516 0-.935-.336-.935-.75s.42-.75.935-.75h25.835c.516 0 .935.336.935.75s-.418.75-.934.75Z",
  fill: "#98A4AF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 53V2a1 1 0 0 1 1-1h28.586a1 1 0 0 1 .707.293l11.914 11.914a1 1 0 0 1 .293.707V53a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z",
  stroke: "#98A4AF",
  strokeWidth: 1.4
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5 1.5V13a1 1 0 0 0 1 1h12",
  stroke: "#98A4AF",
  strokeWidth: 1.4
})));
export { SvgNoDocuments as ReactComponent };
export default __webpack_public_path__ + "902b20b1b7dd71419abcda0765aa81dc.svg";